import {Component, OnInit} from '@angular/core';
import {Site} from "../../api/model/site";
import {AwsService} from "../aws.service";
import {Router} from "@angular/router";

import {Message} from "primeng/components/common/api";

@Component({
    template: require('./site-list.component.pug'),
    styles: [require('./site-list.component.css')]
})
export class SiteListComponent implements OnInit {
    msgs: Message[] = [];
    models: Site[] = [];
    deleteConfirm: boolean = false;

    deleteSite: string;


    constructor(private _awsService: AwsService, private _router: Router) {
    }

    async ngOnInit() {
        this.models = (await this._awsService.api.sitesGet({}, {})).data.items;
    }


    async confirmDelete(id: string) {
        this.deleteSite = id;

        this.deleteConfirm = true;
        console.log(id);
    }

    async remove() { 

        try {
            await this._awsService.api.sitesSiteDelete({site: this.deleteSite}, {});
            this.models = (await this._awsService.api.sitesGet({}, {})).data.items;
            await this._awsService.updateSites();
            this.deleteConfirm = false;

            this.msgs.push({severity: 'success', summary: 'El site se ha eliminado correctamente.'});
            
            setTimeout(()=>{
                this._router.navigate(['/']);
            }, 5000);
            setTimeout(()=>{
                window.location.reload();
            }, 5300);
            
            
     

        } catch (err) {
            console.log(err);
        }
    }

}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/sites/site-list.component.ts